<template>
  <v-app class="bg-color">
    <v-main>
      <v-container fluid grid-list-xs pt-5>
        <v-layout row wrap justify-center align-center>
          <v-flex xs11 lg11>
            <h2>
              <v-icon color="#077893" @click="Fn_BackIndex" size="38"
                >mdi-chevron-left</v-icon
              >{{ $t("petition.text4") }}
            </h2>
          </v-flex>
        </v-layout>
        <v-layout row wrap justify-center align-center>
          <v-flex xs11 lg11 pt-5>
            <v-card class="rounded-lg">
              <v-card-text>
                <v-layout row wrap pa-1 justify-center>
                  <v-flex xs11 lg11>
                    <p class="pt-5">
                      <b>{{ $t("petition.text18") }} : </b> {{ SendCancelId }}
                      <v-icon
                        v-bind="attrs"
                        color="#077893"
                        style="cursor: pointer"
                        small
                        @click="Fn_CopyDetail(SendCancelId)"
                        v-on="on"
                        >mdi-file-multiple-outline</v-icon
                      >
                    </p>
                    <v-card outlined>
                      <v-card-text>
                        <v-form ref="form" v-model="validForm" lazy-validation>
                          <p>
                            <b class="pb-2" style="font-size: 22px">
                              {{ $t("petition.text8") }}
                            </b>
                          </p>
                          <p>
                            <b>{{ $t("petition.text19") }} </b>
                            <span v-if="$t('default') === 'th'">{{
                              NameTh
                            }}</span>
                            <span v-else>{{ NameEng }}</span>
                          </p>
                          <p>
                            <b>{{ $t("petition.text6") }} </b>
                            <span v-if="$t('default') === 'th'">
                              {{ BusinessNameTh }}
                            </span>
                            <span v-else>{{ BusinessNameEng }}</span>
                          </p>
                          <p>
                            <b>{{ $t("petition.text20") }} </b>
                            <a v-on:click="Fn_DetailPolicy"
                              >{{ PolicyHeader }}
                            </a>
                          </p>
                          <p>
                            <b>{{ $t("petition.text21") }}</b>
                          </p>
                          <p
                            v-for="(item, index) in ConsentHeader"
                            :key="item.id"
                          >
                            <a v-on:click="Fn_DetailConsent(item)">
                              {{ index + 1 }}. {{ item.ConsentHeader }}
                            </a>
                          </p>
                          <p>
                            <b>{{ $t("petition.text7") }} </b> {{ TypeName }}
                          </p>

                          <!-- <b>{{ $t("petition.text11") }}</b>
                        <p>{{ SubjectRequest }}</p> -->
                          <p>
                            <b>{{ $t("petition.text12") }} </b>
                            <span v-if="$t('default') === 'th'">{{
                              CreatedAt
                            }}</span>
                            <span v-else>{{ CreatedAtEng }}</span>
                          </p>
                          <b v-if="$t('default') === 'th'"
                            >รายการข้อมูลที่ขอดำเนินการ</b
                          >
                          <b v-else>Requested data list</b>
                          <v-card
                            class="ma-3"
                            outlined
                            color="grey lighten-4"
                            v-for="(item, i) in Tag"
                            :key="i"
                          >
                            <v-container>
                              <b class="mt-3">{{ item.Key }}</b>
                              <p v-if="$t('default') === 'th'">
                                รายละเอียด: {{ item.ReqMessage }}
                              </p>
                              <p v-else>Detail: {{ item.ReqMessage }}</p>
                              <v-radio-group
                                v-if="$t('default') === 'th'"
                                v-model="item.Status"
                                :disabled="Status == 'finished'"
                                row
                                :rules="[(v) => !!v || 'กรุณาเลือก ความยินยอม']"
                              >
                                <v-radio
                                  color="success"
                                  label="ยืนยัน"
                                  value="approve"
                                ></v-radio>
                                <v-divider vertical></v-divider>
                                <v-radio
                                  color="error"
                                  class="ml-5"
                                  label="ปฏิเสธ"
                                  value="unapprove"
                                ></v-radio>
                              </v-radio-group>
                              <v-radio-group
                                v-else
                                v-model="item.Status"
                                :disabled="Status == 'finished'"
                                row
                                :rules="[
                                  (v) => !!v || 'Please enter a Consent',
                                ]"
                              >
                                <v-radio
                                  color="success"
                                  label="approved"
                                  value="approve"
                                ></v-radio>
                                <v-divider vertical></v-divider>
                                <v-radio
                                  color="error"
                                  class="ml-5"
                                  label="Reject"
                                  value="unapprove"
                                ></v-radio>
                              </v-radio-group>
                              <v-text-field
                                v-if="
                                  item.Status == 'unapprove' &&
                                  $t('default') === 'th'
                                "
                                dense
                                outlined
                                label="ระบุเหตุผล"
                                v-model="item.Reason"
                                :rules="[(v) => !!v || 'กรุณากรอกเหตุผล']"
                              ></v-text-field>
                              <v-text-field
                                v-if="
                                  item.Status == 'unapprove' &&
                                  $t('default') === 'en'
                                "
                                dense
                                outlined
                                label="State the reason"
                                v-model="item.Reason"
                                :rules="[(v) => !!v || 'Please enter a reason']"
                              ></v-text-field>
                            </v-container>
                          </v-card>
                          <div v-if="File.length > 0">
                            <b v-if="$t('default') === 'th'">ไฟล์แนบ</b>
                            <b v-else>Files</b>
                            <v-card
                              class="ma-3"
                              outlined
                              color="grey lighten-4"
                            >
                              <v-container>
                                <v-layout row wrap justify-start align-baseline>
                                  <v-flex
                                    xs6
                                    sm6
                                    md3
                                    lg2
                                    pa-3
                                    v-for="(item, i) in File"
                                    :key="i"
                                  >
                                    <v-hover>
                                      <template v-slot:default="{ hover }">
                                        <v-card
                                          @click="Fn_OpenFile(item)"
                                          style="cursor: pointer"
                                          outlined
                                          :elevation="hover ? 24 : 6"
                                          class="mx-auto rounded-xl"
                                        >
                                          <v-card-text class="text-center">
                                            <v-icon color="red" size="40"
                                              >mdi-file-pdf-box</v-icon
                                            >
                                          </v-card-text>
                                          <v-card-actions
                                            class="mt-n3"
                                            style="background: #fafafa"
                                          >
                                            <h4 class="text-truncate">
                                              {{ item.FileName }}
                                            </h4>
                                          </v-card-actions>
                                        </v-card>
                                      </template>
                                    </v-hover>
                                  </v-flex>
                                </v-layout>
                                <!-- <b class="mt-3">{{ item.FileName }}</b>
                            <p>รายละเอียด: {{ item.FileName }}</p> -->
                              </v-container>
                            </v-card>
                          </div>

                          <!-- <b>{{ $t("petition.text13") }}</b>
                        <p>-</p>
                        <b>{{ $t("petition.text14") }}</b> -->
                          <!-- <p v-if="Status === 'pending'" class="warning--text">
                          {{ $t("petition.text17") }}
                        </p>
                        <p v-else class="error--text">-</p> -->
                          <b v-if="$t('default') === 'th'"
                            >วันเวลาที่จะทำการตอบกลับ</b
                          >
                          <b v-else>Date and time to reply</b>
                          <v-card
                            class="ma-3"
                            outlined
                            :disabled="Status !== 'pending'"
                          >
                            <v-container>
                              <v-layout
                                row
                                wrap
                                align-center
                                justify-space-between
                              >
                                <v-flex xs12 lg4 class="ma-2">
                                  <v-menu
                                    ref="menu1"
                                    v-model="menu1"
                                    :close-on-content-click="false"
                                    transition="scale-transition"
                                    offset-y
                                    max-width="290px"
                                    min-width="auto"
                                  >
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-text-field
                                        class="mb-3"
                                        hide-details
                                        :error-messages="valid"
                                        clearable
                                        color="#077893"
                                        dense
                                        outlined
                                        v-model="dateFormatted"
                                        :label="$t('petition.text40')"
                                        prepend-icon="mdi-calendar"
                                        v-bind="attrs"
                                        @blur="date = parseDate(dateFormatted)"
                                        v-on="on"
                                      ></v-text-field>
                                    </template>
                                    <v-date-picker
                                      locale="th"
                                      :min="
                                        new Date(
                                          Date.now() -
                                            new Date().getTimezoneOffset() *
                                              60000
                                        )
                                          .toISOString()
                                          .substring(0, 10)
                                      "
                                      v-model="date"
                                      color="#077893"
                                      no-title
                                      @input="menu1 = false"
                                    ></v-date-picker>
                                  </v-menu>
                                  <v-menu
                                    ref="menu"
                                    v-model="timemenu2"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    :return-value.sync="time"
                                    transition="scale-transition"
                                    offset-y
                                    max-width="290px"
                                    min-width="290px"
                                  >
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-text-field
                                        :error-messages="valid"
                                        clearable
                                        hide-details
                                        color="#077893"
                                        dense
                                        outlined
                                        v-model="time"
                                        :label="$t('petition.text41')"
                                        prepend-icon="mdi-clock-time-four-outline"
                                        readonly
                                        v-bind="attrs"
                                        v-on="on"
                                      ></v-text-field>
                                    </template>
                                    <v-time-picker
                                      format="24hr"
                                      locale="th"
                                      color="#077893"
                                      v-if="timemenu2"
                                      v-model="time"
                                      full-width
                                      @click:minute="$refs.menu.save(time)"
                                    ></v-time-picker>
                                  </v-menu>
                                </v-flex>
                                <v-flex xs12 lg4>
                                  <v-card
                                    outlined
                                    class="pa-3"
                                    v-if="time && dateFormatted"
                                  >
                                    <div
                                      class="font-weight-bold"
                                      v-if="
                                        dateFormatted !== null &&
                                        $t('default') === 'th'
                                      "
                                    >
                                      จะตอบกลับภายในวันที่ {{ thaiDate }}
                                      <br />
                                    </div>
                                    <div
                                      class="font-weight-bold"
                                      v-if="
                                        dateFormatted !== null &&
                                        $t('default') === 'en'
                                      "
                                    >
                                      Will reply within a day {{ engDate }}
                                      <br />
                                    </div>
                                    <div
                                      class="font-weight-bold"
                                      v-if="
                                        time !== null && $t('default') === 'th'
                                      "
                                    >
                                      เวลา {{ time }} น.
                                    </div>
                                    <div
                                      class="font-weight-bold"
                                      v-if="
                                        time !== null && $t('default') === 'en'
                                      "
                                    >
                                      Time {{ time }}
                                    </div>
                                    <v-card-actions>
                                      <v-spacer></v-spacer>
                                      <v-btn
                                        dense
                                        dark
                                        color="#077893"
                                        @click="CheckTime(UpdateTime)"
                                        >{{ $t("upload.swal3") }}</v-btn
                                      >
                                    </v-card-actions>
                                  </v-card>
                                </v-flex>
                              </v-layout>
                            </v-container>
                          </v-card>
                        </v-form>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-card-text>
              <v-card-actions class="pa-5">
                <v-spacer></v-spacer>
                <!-- <v-btn
                  :dark="_Status !== 'pending'"
                  :disabled="_Status !== 'pending'"
                  outlined
                  class="ml-2"
                  color="error"
                  v-model="unapprove"
                  @click="Fn_Request_Cancel(unapprove)"
                >
                  <v-icon left> mdi-close </v-icon>
                  {{ $t("petition.text16") }}
                </v-btn> -->
                <v-btn
                  :disabled="Status !== 'pending'"
                  dense
                  dark
                  color="#077893"
                  @click="Fn_Request_Cancel(approve)"
                  >{{ $t("petition.text15") }}</v-btn
                >
                <!-- <v-btn
                  :disabled="Status !== 'pending'"
                  class="ml-2"
                  dark
                  color="#077893"
                  v-model="approve"
                  @click="Fn_Request_Cancel(approve)"
                >
                  {{ $t("petition.text15") }}
                </v-btn> -->
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
      <DialogPetition
        :show="DialogPetitionDetail"
        :_header="PolicyHeader"
        :_detail="PolicyDetail"
        @closeDialog="DialogPetitionDetail = false"
      />
      <DialogConsent
        :show="DialogConsentDetail"
        :_detail="ConsentDetail"
        @closeDialog="DialogConsentDetail = false"
      />
      <DialogPreviewFile
        :show="DialogPreview"
        :_detail="PDFDetail"
        @closeDialog="DialogPreview = false"
      />
      <div v-if="loadingDownloadData">
        <OverlaySearch />
      </div>
    </v-main>
  </v-app>
</template>

<script>
import DialogConsent from "@/components/dialog/DialogPetitionConsentDetail.vue";
import DialogPetition from "@/components/dialog/DialogPetitionDetail.vue";
import DialogPreviewFile from "@/components/dialog/DialogPreviewFile.vue";
import OverlaySearch from "@/components/layouts/LoadingPage.vue";
import authorization from "@/functions/authorization.js";
import { format } from "date-fns";
import moment from "moment";
import "moment/locale/th";
import Swal2 from "sweetalert2/dist/sweetalert2.js";
import { mapGetters } from "vuex";

const Toast = Swal2.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});
export default {
  components: {
    DialogPetition,
    DialogConsent,
    DialogPreviewFile,
    OverlaySearch,
  },
  data: (vm) => ({
    date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .substr(0, 10),
    dateFormatted: vm.formatDate(
      new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10)
    ),
    validForm: true,
    menu1: false,
    menu2: false,
    time: null,
    timemenu2: false,
    dialogFile: false,
    DialogConsentDetail: false,
    DialogPetitionDetail: false,
    loadingDownloadData: false,
    DialogPreview: false,
    PDFDetail: [],
    BusinessNameTh: "",
    BusinessNameEng: "",
    sst: "",
    Status: "",
    CreatedAt: "",
    CreatedAtEng: "",
    ConsentHeader: "",
    PolicyHeader: "",
    ConsentDetail: "",
    PolicyDetail: "",
    SubjectRequest: "",
    CancelId: "",
    NameTh: "",
    NameEng: "",
    attrs: "",
    on: "",
    approve: "approve",
    unapprove: "unapprove",
    SendCancelId: "",
    TypeName: "",
    Tag: "",
    File: "",
    FileName: "",
    FileBase64: "",
    dateThai: "2022-01-01 12:00:00",
    DataDataTime: "",
    duedatetime: "",
    UpdateTime: "",
    valid: "",
  }),
  computed: {
    ...mapGetters(["DataPetition"]),
    ...mapGetters(["Business"]),
    _SendId: {
      get() {
        return this.DataPetition.SendId || "-";
      },
    },
    _SubjectRequest: {
      get() {
        return this.DataPetition.SubjectRequest || "-";
      },
    },
    _SendCancelId: {
      get() {
        return this.DataPetition.SendCancelId || "-";
      },
    },
    _Status: {
      get() {
        return this.DataPetition.Status || "-";
      },
    },
    _Type: {
      get() {
        return this.DataPetition.Type || "-";
      },
    },
    Data: {
      get() {
        return this.DataPetition || "-";
      },
    },
    _date: {
      get() {
        if (this.dateFormatted === "" || this.dateFormatted === null) {
          return "null";
        } else {
          return (
            format(new Date(this.date), "yyyy-MM-dd") + "T" + this.time + ":00"
          );
        }
      },
    },
    thaiDate() {
      moment.locale("th");
      return moment(this.date).format("LL");
    },
    engDate() {
      moment.locale("en");
      return moment(this.date).format("LL");
    },
  },
  mounted() {
    this.Request_Cancel_Admin();
    this.Fn_DueDate();
  },
  watch: {
    date(val) {
      this.dateFormatted = this.formatDate(this.date);
    },
  },
  methods: {
    CheckTime(val) {
      if (val == "update") {
        this.ConFirmDateTime();
      } else if (val == "edit") {
        this.Fn_EditDueDate();
      }
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      // return `${month}/${day}/${year}`;
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [month, day, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    async Fn_Request_Cancel(val) {
      if (this.$refs.form.validate()) {
        this.loadingDownloadData = true;
        var payload = {
          AccountId: this.$cookies.get("OneAccountId"),
          Tag: this.Tag,
          Type: this.detail.Type,
          SendCancelId: this.SendCancelId,
          AccessToken: this.$cookies.get("OneAccessToken"),
        };
        var Headers = {
          AccountId: this.$cookies.get("OneAccountId"),
        };
        var dataEncode = await authorization.encodeDataNew(payload);
        var auth = await authorization.encodeDataNew(Headers);
        var headers = { Authorization: "Bearer " + auth };
        this.axios
          .post(
            process.env.VUE_APP_API_FACTORING_SERVICE +
              "business/Pettition/Confirm",
            { Data: dataEncode },
            { headers }
          )
          .then((response) => {
            this.loadingDownloadData = false;

            if (response.data.Status === "OK") {
              this.cancel = response.data.Message;
              Toast.fire({
                icon: "success",
                title: this.$i18n.t("alert.success"),
              });
              this.$router.push("/petition-index");
              // window.location.reload();
            } else {
              Toast.fire({
                icon: "error",
                title: response.data.Message.Status,
              });
            }
          })
          .catch((error) => {
            this.loadingDownloadData = false;
            if (error.response) {
              Toast.fire({
                icon: "error",
                title: error.response.data.ErrorMessage,
              });
            } else if (error.request) {
              Toast.fire({
                icon: "error",
                title: error.request,
              });
            } else {
              Toast.fire({
                icon: "error",
                title: error.message || error,
              });
            }
          });
      }
    },
    async Request_Cancel_Admin() {
      this.loadingDownloadData = true;

      var payload = {
        // AccountId: this.$cookies.get("OneAccountId"),
        // BusinessId: this.$cookies.get("BusinessId"),
        SendCancelId: this._SendCancelId,
        Type: this._Type,
        AccessToken: this.$cookies.get("OneAccessToken"),
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            "business/Pettition/GetRequest",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          this.loadingDownloadData = false;

          if (response.data.Status === "OK") {
            this.detail = response.data.Message;
            this.BusinessNameTh = response.data.Message.BusinessNameTh;
            this.BusinessNameEng = response.data.Message.BusinessNameEng;
            this.TypeName = response.data.Message.TypeName;
            this.CreatedAt = response.data.Message.CreatedAt;
            this.CreatedAtEng = response.data.Message.CreatedAtEng;
            this.PolicyHeader = response.data.Message.PolicyHeader;
            this.PolicyDetail = response.data.Message.PolicyDetail;
            this.Status = response.data.Message.Status;
            this.SubjectRequest = response.data.Message.SubjectRequest;
            this.SendCancelId = response.data.Message.SendCancelId;
            this.NameTh = response.data.Message.NameTh;
            this.NameEng = response.data.Message.NameEng;
            this.ConsentHeader = response.data.Message.Consent;
            this.Tag = response.data.Message.Tag;
            this.File = response.data.Message.File;
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.Message.Status,
            });
          }
        })
        .catch((error) => {
          this.loadingDownloadData = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    Fn_BackIndex() {
      this.$router.push("/petition-index");
    },
    Fn_DetailPolicy() {
      this.DialogPetitionDetail = true;
    },
    Fn_DetailConsent(val) {
      this.ConsentDetail = val;
      this.DialogConsentDetail = true;
    },
    async Fn_CopyDetail(val) {
      await navigator.clipboard.writeText(val);
    },
    async Fn_OpenFile(val) {
      var headers = {
        Authorization: "Bearer " + this.$cookies.get("OneAccessToken"),
      };
      this.axios
        .get(val.File, { headers })
        .then((response) => {
          if (response.data.Status === "OK") {
            this.PDFDetail = response.data.Message;
            this.DialogPreview = true;
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.Message.Status,
            });
          }
        })
        .catch((error) => {
          this.loadingDownloadData = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    async ConFirmDateTime() {
      this.loadingDownloadData = true;
      this.DataDataTime = this._date;
      var payload = {
        AccountId: this.$cookies.get("OneAccountId"),
        DueDate: this.DataDataTime,
        SendCancelId: this.SendCancelId,
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE + "business/InsertDueDate",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          this.loadingDownloadData = false;

          if (response.data.Status === "OK") {
            this.DateTime = response.data.Message;
            Toast.fire({
              icon: "success",
              title: this.$i18n.t("alert.success"),
            });
            this.$router.push("/petition-index");
            // window.location.reload();
          } else {
            this.valid = "error";
            Toast.fire({
              icon: "error",
              title: response.data.Message.Status,
            });
          }
        })
        .catch((error) => {
          this.valid = "error";
          this.loadingDownloadData = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    async Fn_DueDate() {
      this.loadingDownloadData = true;
      var payload = {
        AccountId: this.$cookies.get("OneAccountId"),
        SendCancelId: this._SendCancelId,
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE + "business/GetDueDate",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          // this.loadingDownloadData = false;

          if (response.data.Status === "OK") {
            this.duedatetime = response.data.Message;
            this.DueDate = response.data.Message[0].DueDate;
            if (this.DueDate == null) {
              this.date = new Date(
                Date.now() - new Date().getTimezoneOffset() * 60000
              )
                .toISOString()
                .substr(0, 10);
              this.time = "";
              this.UpdateTime = "update";
            } else {
              this.date = this.DueDate.slice(0, 10);
              this.time = this.DueDate.slice(11, 16);
              this.UpdateTime = "edit";
            }
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.Message.Status,
            });
          }
        })
        .catch((error) => {
          this.loadingDownloadData = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    async Fn_EditDueDate() {
      this.loadingDownloadData = true;
      this.DataDataTime = this._date;
      var payload = {
        AccountId: this.$cookies.get("OneAccountId"),
        DueDate: this.DataDataTime,
        SendCancelId: this._SendCancelId,
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE + "business/UpdateDueDate",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          // this.loadingDownloadData = false;

          if (response.data.Status === "OK") {
            this.duedateupdate = response.data.Message;
            Toast.fire({
              icon: "success",
              title: this.$i18n.t("alert.success"),
            });
            this.$router.push("/petition-index");
          } else {
            this.valid = "error";
            Toast.fire({
              icon: "error",
              title: response.data.Message.Status,
            });
          }
        })
        .catch((error) => {
          this.valid = "error";
          this.loadingDownloadData = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
  },
};
</script>

<style></style>

<style scoped>
.bg-color {
  background-color: #ddf7ff;
}
</style>
